import { useAppDispatch, useAppSelector } from 'app/hooks';
import { KEY_THEME_LOCALSTORAGE } from 'consts/app';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { selectIsDarkMode, setIsDarkMode } from 'redux/userSlice';
import { setLocalStorage } from 'utils/sessionStorage';

const useThemes = () => {
  const isDarkMode = useAppSelector(selectIsDarkMode);
  const dispatch = useAppDispatch();

  const { switcher, themes } = useThemeSwitcher();

  const toggleDarkMode = () => {
    switcher({ theme: isDarkMode ? themes.light : themes.dark });
    setLocalStorage(KEY_THEME_LOCALSTORAGE, isDarkMode ? 'light' : 'dark');
    dispatch(setIsDarkMode(!isDarkMode));
  };

  const toggle = (isLightMode: boolean) => {
    switcher({ theme: isLightMode ? themes.light : themes.dark });
    setLocalStorage(KEY_THEME_LOCALSTORAGE, isLightMode ? 'light' : 'dark');
    dispatch(setIsDarkMode(!isLightMode));
  };

  return {
    currentTheme: isDarkMode ? 'dark' : 'light',
    toggleDarkMode,
    toggle,
  };
};

export default useThemes;
